import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { InteroperableDataService } from '../../services/interoperableDataService';

export const SelectCountry = ({
  selectedCountry,
  onChange,
  placeholder = 'countryPlaceholder',
  getData,
  disabled,
  maskLabel,
}) => {
  const { translate: t } = useDictionaryTranslation();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectCountry = (item) => {
    const country = countries.find((s) => s._id === item.value);
    onChange(country);
  };

  const getCountries = useCallback(async (search) => {
    setLoading(true);
    try {
      const params = { search, isServiceCreation: true };
      const { countries: countriesList } = await getData(params);
      setCountries(countriesList);
    } catch (error) {
      setCountries([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const getOptionData = useCallback((country) => {
    return {
      value: country._id,
      label: country.common_name,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t(placeholder)}
      isLoading={loading}
      onChange={selectCountry}
      options={countries}
      value={selectedCountry}
      onSearch={getCountries}
      getOptionData={getOptionData}
      disabled={disabled}
      maskLabel={maskLabel}
    />
  );
};

SelectCountry.propTypes = {
  selectedCountry: PropTypes.shape({
    iso_alpha3_code: PropTypes.string,
    common_name: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  getData: PropTypes.func,
  disabled: PropTypes.bool,
  maskLabel: PropTypes.func,
};

SelectCountry.defaultProps = {
  getData: InteroperableDataService.getCountries,
};
